import { render, staticRenderFns } from "./RootFabbricatiIdView.vue?vue&type=template&id=d5ab5ca0&"
import script from "./RootFabbricatiIdView.vue?vue&type=script&lang=ts&"
export * from "./RootFabbricatiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports